function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  background-color: transparent;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: 0.3s ease-in opacity;\n  opacity: 0;\n  pointer-events: none;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { TiBackspaceOutline } from "react-icons/ti";
var InlineIconButton = function(IconComponent) {
    return styled(function(_param) /*#__PURE__*/ {
        var isVisible = _param.isVisible, props = _objectWithoutProperties(_param, [
            "isVisible"
        ]);
        return React.createElement("button", _extends({}, props), /*#__PURE__*/ React.createElement(IconComponent, {
            size: "1.5em"
        }));
    })(_templateObject(), function(param) {
        var theme = param.theme;
        return theme.palette.neutral;
    }, function(param) {
        var isVisible = param.isVisible;
        return isVisible && "\n    opacity: 1;\n    pointer-events: inherit;\n  ";
    });
};
var ResetInputButton = InlineIconButton(TiBackspaceOutline);
export default ResetInputButton;
